import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ir_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ---- pageview beacon dedup ----
// Multiple beacons fire for a single logical pageview:
//   • React 18 StrictMode double-invokes effects
//   • React Router route transitions cause parent re-mounts that
//     re-run the useEffect a second time
//   • The back button re-fires the same route immediately
// A tiny module-level guard keyed on (path, article_id) with a
// short TTL collapses these into a single beacon per real
// pageview without needing to hunt down every remount cause.
let _lastBeacon = { key: "", ts: 0 };
const _DEDUP_WINDOW_MS = 2500;

export const trackPageview = (path, article_id = null) => {
  const key = `${path}|${article_id || ""}`;
  const now = Date.now();
  if (key === _lastBeacon.key && now - _lastBeacon.ts < _DEDUP_WINDOW_MS) {
    return; // dedup — same pageview beacon fired seconds ago
  }
  _lastBeacon = { key, ts: now };

  // Send the raw referrer as-is; the server now classifies internal
  // navigation into its own bucket, so we don't need to strip
  // same-origin referrers on the client.
  const referrer = (typeof document !== "undefined" && document.referrer) || "";

  // Capture UTM params off the current URL so tagged campaign links
  // (WhatsApp digest, email, social share links) get attributed to
  // their real acquisition channel even when the browser strips the
  // referrer.
  let utm_source = null;
  let utm_medium = null;
  let utm_campaign = null;
  try {
    const q = new URLSearchParams(window.location.search || "");
    utm_source = q.get("utm_source");
    utm_medium = q.get("utm_medium");
    utm_campaign = q.get("utm_campaign");
  } catch (_) { /* no-op */ }

  api.post("/analytics/pageview", {
    path,
    article_id,
    referrer,
    utm_source,
    utm_medium,
    utm_campaign,
  }).catch(() => {});
};
